<template>
  <div class="app-container">
    <wd-navbar>
      <div slot="left" class="middle" @click="$goHome">
        <wd-icon name="arrow-left" />
      </div>
      <div>
        <span>绑定项目</span>
      </div>
    </wd-navbar>

    <wd-select-picker
      label="项目"
      value-key="roleId"
      label-key="roleName"
      type="radio"
      v-model="value"
      :columns="roleList"
      :filterable="true"
      filter-placeholder="请输入项目名称进行匹配"
      ref="iSelectPicker"
      @cancel="filterDisplay"
    ></wd-select-picker>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 10px;
      "
    >
      <span style="font-size: 14px">
        <font style="color: #e6a23c">温馨提醒：</font>
        <font>请通过搜索并选择自己归属的项目绑定！</font>
      </span>
    </div>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 10px;
      "
    >
      <wd-button
        type="info"
        icon="wd-icon-check"
        @click="update"
        :loading="loading"
        >确认绑定</wd-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      roleList: [],
      value: "",
      phoneNum: "",
      isInputEvent: true,
    };
  },
  created() {
    this.$http.get("/external/sysRole/list").then((res) => {
      if (res.code == 200) {
        this.roleList = res.rows;
      }
    });
    this.phoneNum = localStorage.getItem("phoneNum");
    // this.value = localStorage.getItem("roleId");
  },
  computed: {
    searchVal() {
      return this.$refs.iSelectPicker.filterVal;
    },
  },
  mounted() {
    // 注册项目筛选框显隐事件
    document
      .querySelector(".wd-search__block")
      .addEventListener("mousedown", () => {
        this.isInputEvent = false;
        this.filterDisplay();
        this.isInputEvent = true;
      });
    document
      .querySelector(".wd-search__input")
      .addEventListener("input", () => {
        if (this.isInputEvent) {
          this.filterDisplay();
        }
      });
    // if (this.value) {
    //   this.update(false);
    // }
  },
  methods: {
    // 项目筛选框显隐事件
    filterDisplay() {
      if (this.searchVal.trim() != "") {
        // console.log("yes");
        document
          .querySelector(".wd-select-picker__wrapper")
          .querySelector(".wd-radio-group").style.display = "block";
      } else {
        // console.log("no");
        document
          .querySelector(".wd-select-picker__wrapper")
          .querySelector(".wd-radio-group").style.display = "none";
      }
    },
    update(isInitBinnd = true) {
      if (!this.value) return this.$toast.error("清先选择自己的归属项目！");
      this.loading = true;
      this.$http
        .put("/external/appUser/update", {
          // put
          phoneNum: this.phoneNum,
          roleId: this.value,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$http
              .get("/external/appUser/list", {
                params: { phoneNum: this.phoneNum },
              })
              .then((res) => {
                if (res.code == 200) {
                  localStorage.setItem("appUserId", res.user.appUserId);
                  localStorage.setItem("phoneNum", res.user.phoneNum);
                  if (res.user.roleId) {
                    localStorage.setItem("roleKey", res.user.roleId);
                  } else {
                    localStorage.removeItem("roleKey");
                  }
                  if (res.user.roleIds) {
                    localStorage.setItem("roleIds", res.user.roleIds);
                  } else {
                    localStorage.removeItem("roleIds");
                  }
                  if (res.user.rolePhoneNum) {
                    localStorage.setItem("rolePhoneNum", res.user.rolePhoneNum);
                  } else {
                    localStorage.removeItem("rolePhoneNum");
                  }
                  if (
                    res.user.roleIds &&
                    res.user.roleIds.includes(res.user.roleId + "")
                  ) {
                    localStorage.setItem("showControl", "true");
                  } else {
                    localStorage.setItem("showControl", "false");
                  }
                  this.loading = false;
                  if (isInitBinnd) {
                    this.$toast.success("绑定成功！");
                  }
                  localStorage.removeItem("openId");
                  if (isInitBinnd) {
                    this.$router.push("/home");
                  }
                } else {
                  this.$toast.error(res.msg);
                }
              });
          } else {
            this.$toast.error(res.msg);
          }
        });
    },
  },
};
</script>

<style lang="less">
.wd-select-picker__wrapper .wd-radio-group {
  display: none;
}
</style>
